function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import logger from "../logger";
var PubSub = /*#__PURE__*/ function() {
    "use strict";
    function PubSub() {
        this.listeners = {};
        this.unsubscribe = this.unsubscribe.bind(this);
        this.subscribe = this.subscribe.bind(this);
        this.publish = this.publish.bind(this);
    }
    var _proto = PubSub.prototype;
    _proto.unsubscribe = function unsubscribe(name, callback) {
        if (!Object.prototype.hasOwnProperty.call(this.listeners, name)) return;
        var i = this.listeners[name].indexOf(callback);
        if (i > -1) this.listeners[name].splice(i, 1);
    };
    _proto.subscribe = function subscribe(name, callback) {
        var _this = this;
        if (!Object.prototype.hasOwnProperty.call(this.listeners, name)) {
            this.listeners[name] = [];
        }
        this.listeners[name].push(callback);
        return function() {
            _this.unsubscribe(name, callback);
        };
    };
    _proto.publish = function publish(name) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        var _this_listeners_name, _this_listeners;
        try {
            logger.debug("Event: " + JSON.stringify({
                name: name,
                args: args
            }));
        } catch (err) {
            // Args were not serializable
            logger.debug("Event: " + JSON.stringify({
                name: name
            }));
        }
        var promises = ((_this_listeners = this.listeners) == null ? void 0 : (_this_listeners_name = _this_listeners[name]) == null ? void 0 : _this_listeners_name.map(function(callback) {
            try {
                return callback.apply(void 0, _to_consumable_array(args));
            } catch (error) {
                return Promise.reject(error);
            }
        })) || [];
        // Using all settled to allow errors
        return Promise.all(promises.map(function(promise) {
            if (!promise) {
                return promise;
            }
            return promise.then(function(value) {
                return {
                    state: "fulfilled",
                    value: value
                };
            }).catch(function(reason) {
                return {
                    state: "rejected",
                    reason: reason
                };
            });
        }));
    };
    return PubSub;
}();
// Really simple pubsub
export { PubSub as default };
// global pubsub for Lapel
var instance = new PubSub();
export var subscribe = instance.subscribe, unsubscribe = instance.unsubscribe, publish = instance.publish;

//# sourceMappingURL=pubsub.js.map